import { createGenerateClassName } from "@material-ui/styles"

const CLASS_NAME_GENERATOR = createGenerateClassName()

export default () => CLASS_NAME_GENERATOR
